import {FC, useState, useEffect, createContext, useContext, useRef} from 'react'
import {LayoutSplashScreen} from '../../../../_metronic/layout/core'
import * as authHelper from './AuthHelpers'
import {WithChildren} from '../../../../_metronic/helpers'
import {vw_application_user} from 'openapi'
import {isExpired} from 'react-jwt'

type AuthContextProps = {
  isAuthenticated: boolean | undefined
  setIsAuthenticated: (value: string) => void
  getToken: () => string | undefined
  getUser: () => vw_application_user | undefined
  logout: () => void
}

const initAuthContextPropsState = {
  isAuthenticated: authHelper.isAuthenticated(),
  setIsAuthenticated: () => {},
  getToken: () => authHelper.getToken(),
  getUser: () => authHelper.getUser(),
  logout: () => {},
}

const AuthContext = createContext<AuthContextProps>(initAuthContextPropsState)

const useAuth = () => {
  return useContext(AuthContext)
}

const AuthProvider: FC<WithChildren> = ({children}) => {
  const [isAuthenticated, setIsAuth] = useState<boolean | undefined>(authHelper.isAuthenticated())

  const setIsAuthenticated = async (value: string | null) => {
    if (value == null) {
      setIsAuth(false)
      authHelper.logout()
    } else {
      // var result = (await authHelper.claimToken(value!)) as ApiResponse
      // if (result.data) {
      setIsAuth(true)
      authHelper.setIsAuthenticated(true)

      // auth.actions.SetUser(result?.data)
      // } else {
      //   MarvelToast.error(result?.message ?? 'Failed to claim token.')
      //   authHelper.logout()
      // }
    }
  }

  const getToken = () => {
    return authHelper.getToken()
  }

  const getUser = () => {
    return authHelper.getUser()
  }

  const logout = () => {
    setIsAuthenticated(null)
    authHelper.logout()
  }

  return <AuthContext.Provider value={{isAuthenticated, setIsAuthenticated, getToken, getUser, logout}}>{children}</AuthContext.Provider>
}

const AuthInit: FC<WithChildren> = ({children}) => {
  const {isAuthenticated, logout, getToken} = useAuth()
  const didRequest = useRef(false)
  const [showSplashScreen, setShowSplashScreen] = useState(true)

  useEffect(() => {
    const token = getToken()
    const checkValidity = () => {
      try {
        if (token && isExpired(token)) {
          logout()
        }
      } catch (error) {
      } finally {
        setShowSplashScreen(false)
      }
      return () => (didRequest.current = true)
    }

    if (isAuthenticated) {
      checkValidity()
    } else {
      logout()
      setShowSplashScreen(false)
    }
    // eslint-disable-next-line
  }, [isAuthenticated])

  return showSplashScreen ? <LayoutSplashScreen /> : <>{children}</>
}

export {AuthProvider, AuthInit, useAuth}
